// @ts-nocheck
(() => {
  const root = document.querySelector('[data-orders-root]');
  if (!root) return;

  const PROXY = '/apps/orders';
  const orderNumericId = (gidOrId) => String(gidOrId).split('/').pop();
  const liveRegion = root.querySelector('[data-orders-status]');

  loadCancellations();
  loadReturns();
  loadDelays();
  upgradeDeliveryStatus();
  setupTabs();
  setupSort();
  setupCardNavigation();

  function setupTabs() {
    const tabs = root.querySelectorAll('.orders-tab');
    const cards = root.querySelectorAll('.order-card');
    tabs.forEach(tab => {
      tab.addEventListener('click', () => {
        tabs.forEach(t => {
          t.classList.toggle('is-active', t === tab);
          t.setAttribute('aria-pressed', t === tab ? 'true' : 'false');
        });
        const filter = tab.dataset.filter;
        let shown = 0;
        cards.forEach(card => {
          // `returns` filters on a flag loadReturns() stamps on, not on the
          // Liquid-rendered open/completed state — a returning order can be
          // either.
          const show = filter === 'all'
            ? true
            : filter === 'returns'
              ? card.dataset.orderReturn === 'true'
              : card.dataset.orderState === filter;
          card.hidden = !show;
          if (show) shown += 1;
        });
        const noun = filter === 'returns' ? 'order with a return' : 'order';
        announce(`Showing ${shown} ${noun}${shown === 1 ? '' : 's'}`);
      });
    });
  }

  function setupSort() {
    const select = root.querySelector('[data-orders-sort]');
    const list = root.querySelector('[data-orders-list]');
    if (!select || !list) return;
    select.addEventListener('change', () => {
      const mode = select.value;
      const cards = Array.from(list.querySelectorAll('.order-card'));
      cards.sort((a, b) => {
        const da = Number(a.dataset.orderDate || 0);
        const db = Number(b.dataset.orderDate || 0);
        const ta = parseFloat(a.dataset.orderTotal || '0');
        const tb = parseFloat(b.dataset.orderTotal || '0');
        switch (mode) {
          case 'oldest': return da - db;
          case 'total-desc': return tb - ta;
          case 'total-asc': return ta - tb;
          case 'recent':
          default: return db - da;
        }
      });
      cards.forEach(c => list.appendChild(c));
      const opt = select.options[select.selectedIndex];
      announce(`Sorted by ${opt ? opt.textContent.trim() : mode}`);
    });
  }

  async function upgradeDeliveryStatus() {
    // Only fully-shipped orders are delivery candidates (a partial ship uses
    // `is-partial`, not `is-complete`). Fire the lookups concurrently so one
    // slow/absent proxy response can't serialize the whole page.
    const cards = Array.from(root.querySelectorAll('[data-order-progress]'))
      .filter(progress => progress.querySelector('[data-progress-step="shipped"].is-complete'));
    await Promise.allSettled(cards.map(async (progress) => {
      const orderId = orderNumericId(progress.dataset.orderId);
      const { ok, data } = await call(`/orders/${orderId}/tracking`);
      if (!ok || !data?.tracking?.length) return;
      const delivered = data.tracking.some(t => (t.status || '').toUpperCase() === 'DELIVERED');
      const delStep = progress.querySelector('[data-progress-step="delivered"]');
      if (!delivered || !delStep) return;
      delStep.classList.add('is-complete');
      const deliveredEvent = data.tracking
        .flatMap(t => t.events || [])
        .find(ev => (ev.status || '').toUpperCase() === 'DELIVERED');
      if (deliveredEvent && deliveredEvent.at) {
        const date = new Date(deliveredEvent.at);
        if (!isNaN(date)) {
          const time = document.createElement('time');
          time.className = 'order-progress__time';
          time.textContent = date.toLocaleDateString(undefined, { month: 'short', day: '2-digit' });
          delStep.appendChild(time);
        }
      }
    }));
  }

  async function loadCancellations() {
    const { ok, data } = await call('/cancellations');
    if (!ok || !data?.cancellations) return;
    Object.entries(data.cancellations).forEach(([orderId, info]) => {
      const card = root.querySelector(`[data-order-id$="/${orderId}"], [data-order-id="${orderId}"]`);
      if (!card) return;
      const banner = card.querySelector('[data-cancellation]');
      // If the order is already cancelled, the Liquid-rendered "cancelled on X"
      // notice is the source of truth — don't override it with a stale pending row.
      const isCancelled = card.dataset.orderCancelled === 'true';
      if (info.status === 'pending' && !isCancelled) {
        banner.hidden = false;
        banner.innerHTML = `<p><strong>Cancellation requested.</strong> Awaiting review by our team.<br><small>Reason: ${escapeHtml(info.customerReason)}</small></p>`;
      } else if (info.status === 'cancel_submitted' && !isCancelled) {
        banner.hidden = false;
        banner.innerHTML = `<p><strong>Cancellation submitted.</strong> We're finalizing it with the store — your refund will follow shortly once it's confirmed.</p>`;
      } else if (info.status === 'awaiting_acceptance' && !isCancelled) {
        banner.hidden = false;
        banner.innerHTML = `<p><strong>Cancellation requested.</strong> We'll process it as soon as the supplier picks up your order. If it ships first, you'll be able to return it instead.</p>`;
      } else if (info.status === 'awaiting_supplier' && !isCancelled) {
        banner.hidden = false;
        banner.innerHTML = `<p><strong>Cancellation requested.</strong> We've asked the supplier to cancel this order — they usually respond within about two business days, and we'll email you as soon as they do. If they've already started shipping you'll be able to return it instead; if it never ships, it's cancelled automatically.</p>`;
      } else if (info.status === 'approved') {
        banner.hidden = false;
        banner.innerHTML = `<p><strong>Cancellation approved.</strong> Your refund is being processed.</p>`;
      } else if (info.status === 'denied' && !isCancelled) {
        banner.hidden = false;
        // Return CTA links to the ODP (cancel/return actions live there now).
        const numericId = orderId;
        // No "Request a return instead" button (owner, 2026-10-08) — the
        // order page carries each delivered shipment's own return action.
        const returnCta = '';
        if (info.deniedBy === 'supplier') {
          const detail = info.deniedReason ? `<br><small>${escapeHtml(info.deniedReason)}</small>` : '';
          banner.innerHTML = `<p><strong>This order can no longer be cancelled.</strong> The supplier has already begun preparing it — you can request a return once it arrives.${detail}</p>${returnCta}`;
        } else {
          banner.innerHTML = `<p><strong>Cancellation denied.</strong><br><small>Reason: ${escapeHtml(info.deniedReason || 'No reason provided')}</small></p>${returnCta}`;
        }
      } else if (info.status && info.status !== 'pending' && info.status !== 'denied' && !isCancelled) {
        banner.hidden = false;
        banner.innerHTML = `<p><strong>Cancellation status:</strong> ${escapeHtml(info.status)}</p>`;
      }
    });
  }

  // Persistent return-status banner. Mirrors loadCancellations(): fetch the
  // customer's returns on load and render a per-order banner so a submitted
  // return (and its return label, once the supplier/Collective generates one)
  // stays visible across visits instead of only showing once at submit time.
  const RETURN_STATUS_LABELS = {
    pending: 'Return requested',
    requested: 'Return requested',
    approved: 'Return approved',
    label_sent: 'Return label ready',
    in_transit: 'Return in transit',
    received: 'Return received',
    refunded: 'Refunded',
    rejected: 'Return declined',
    cancelled: 'Return cancelled',
    closed: 'Return closed',
    complete: 'Return complete',
    partial: 'Return in progress',
  };
  async function loadReturns() {
    const { ok, data } = await call('/returns');
    if (!ok || !data?.returns) return;
    let marked = 0;
    Object.entries(data.returns).forEach(([orderId, info]) => {
      const card = root.querySelector(`[data-order-id$="/${orderId}"], [data-order-id="${orderId}"]`);
      if (!card) return;
      card.dataset.orderReturn = 'true';
      marked += 1;
      const banner = card.querySelector('[data-return-status]');
      if (!banner) return;
      // Headline only. The per-location rows that used to live here ("Shop
      // location: Return label ready — Download return label ↗ (FedEx …)") were
      // unreadable on a summary card and named a warehouse rather than the item
      // being returned. The label now sits on the detail page, next to the items
      // it actually covers.
      const headline = RETURN_STATUS_LABELS[info.status] || 'Return in progress';
      banner.hidden = false;
      // Name what is coming back ("Return requested: Sleep Sack + 1 more"), so a
      // partial return doesn't read as the whole order. Older returns carry no
      // items and keep the bare headline.
      const items = Array.isArray(info.items) ? info.items : [];
      const named = items.length
        ? `: ${escapeHtml(items[0].title)}${items[0].quantity > 1 ? ` &times; ${items[0].quantity}` : ''}${items.length > 1 ? ` + ${items.length - 1} more` : ''}`
        : '';
      banner.innerHTML = `<p><strong>${escapeHtml(headline)}${named}.</strong> <a href="/pages/order-detail?id=${escapeHtml(orderId)}">View return details</a></p>`;
    });
    // Reveal the Returns tab only once we know there's something behind it.
    const tab = root.querySelector('[data-returns-tab]');
    const count = root.querySelector('[data-returns-count]');
    if (tab && marked > 0) {
      if (count) count.textContent = String(marked);
      tab.hidden = false;
    }
  }

  // "Delayed" on each order running late: an item past its ship-by date and
  // not shipped, or checkout's delivery window over and not delivered (Birch
  // Order Management → Shipping & Returns). One request for the whole page,
  // after it renders; shipped orders are sent too — a parcel can be late in
  // transit. The worker only reads live the orders already past a date.
  async function loadDelays() {
    const ids = Array.from(root.querySelectorAll('.order-card'))
      .filter(card => card.dataset.orderCancelled !== 'true')
      .map(card => orderNumericId(card.dataset.orderId || ''))
      .filter(id => /^\d+$/.test(id))
      .slice(0, 50);
    if (!ids.length) return;
    const { ok, data } = await call(`/deliveries?ids=${ids.join(',')}`).catch(() => ({ ok: false, data: null }));
    if (!ok || !data?.late) return;
    Object.entries(data.late).forEach(([orderId, info]) => {
      const card = root.querySelector(`[data-order-id$="/${orderId}"], [data-order-id="${orderId}"]`);
      const badge = card && card.querySelector('[data-delayed-badge]');
      if (!badge || !info?.since) return;
      const due = formatDay(info.since);
      const why = info.kind === 'ship' ? `Was expected to ship by ${due}`
        : info.kind === 'delivery' ? `Was estimated to arrive by ${due}`
          : `Running late since ${due}`;
      badge.title = why;
      badge.setAttribute('aria-label', `Delayed. ${why}.`);
      badge.hidden = false;
      card.dataset.orderLate = 'true';
    });
  }

  // A calendar day ("2026-10-01") as "Thu, Oct 1", read at UTC noon so no
  // browser time zone moves it to a neighbouring day.
  function formatDay(day) {
    const d = new Date(`${day}T12:00:00Z`);
    return isNaN(d) ? String(day) : d.toLocaleDateString(undefined, { weekday: 'short', month: 'short', day: 'numeric', timeZone: 'UTC' });
  }

  async function call(path, opts = {}) {
    // Guard against a missing leading slash collapsing PROXY + path into a
    // malformed route, e.g. '/apps/orders' + 'orders/1/tracking'.
    const route = path.charAt(0) === '/' ? path : '/' + path;
    const res = await fetch(PROXY + route, {
      method: opts.method || 'GET',
      headers: opts.body ? { 'Content-Type': 'application/json' } : {},
      body: opts.body ? JSON.stringify(opts.body) : undefined,
      credentials: 'same-origin',
    });
    return { ok: res.ok, status: res.status, data: await res.json().catch(() => null) };
  }

  // Whole-card navigation. The card is a summary now — tracking and the invoice
  // both live on the detail page — so the natural gesture is "open the order".
  //
  // Deliberately NOT a stretched-link overlay and NOT a role="button" card: an
  // overlay would swallow text selection over the item titles and totals, and a
  // focusable card would duplicate the "View details" link in the tab order for
  // no gain. This is a pointer convenience layered on a real link, which remains
  // the keyboard and screen-reader path.
  function setupCardNavigation() {
    const list = root.querySelector('[data-orders-list]');
    if (!list) return;
    list.addEventListener('click', (e) => {
      // Anything genuinely interactive handles its own click: the details link,
      // a return-label download, the cancellation banner's CTA.
      if (e.target.closest('a, button, input, select, textarea, label, [role="button"]')) return;
      const card = e.target.closest('.order-card');
      const link = card && card.querySelector('[data-order-details-link]');
      if (!link) return;
      // Don't hijack the mouse-up that ends a text selection inside the card.
      const selection = window.getSelection();
      if (selection && !selection.isCollapsed && card.contains(selection.anchorNode)) return;
      // Match a real link's modifier behaviour rather than stealing the click.
      if (e.metaKey || e.ctrlKey || e.shiftKey) {
        window.open(link.href, '_blank', 'noopener');
        return;
      }
      window.location.assign(link.href);
    });
  }

  function escapeHtml(s) {
    return String(s ?? '').replace(/[&<>"']/g, c => ({
      '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;',
    }[c]));
  }

  // Politely announce filter/sort changes to assistive tech via the live region.
  function announce(msg) {
    if (liveRegion) liveRegion.textContent = msg;
  }

})();
